import { FC } from 'react'

import ProfileImage from 'components/UI/ProfileImage'

import { Button } from 'ui'

type ProfileImageWithActionsProps = {
  className?: string
  firstName?: string
  lastName?: string
  pictureUrl: string | null
  size?: number
  variant?: 'circle' | 'square'
  onEdit?: () => void
  onDelete?: () => void
}

const ProfileImageWithActions: FC<ProfileImageWithActionsProps> = ({
  className,
  firstName,
  lastName,
  pictureUrl,
  size = 200,
  variant = 'square',
  onEdit,
  onDelete
}) => {
  return (
    <div className="mx-auto d-block" style={{ position: 'relative' }}>
      <ProfileImage className={className} variant={variant} size={size} firstName={firstName} lastName={lastName} pictureUrl={pictureUrl} />
      {onEdit ? (
        <Button
          className="rounded-circle border-0"
          size="small"
          color="light"
          data-cy="edit-profile-picture"
          data-testid="edit-profile-picture"
          style={{ position: 'absolute', zIndex: '2', left: '80%', top: '80%' }}
          onClick={onEdit}
        >
          <i className="fa-solid fa-pen"></i>
        </Button>
      ) : null}
      {onDelete && pictureUrl ? (
        <Button
          className="rounded-circle border-0"
          size="small"
          color="light"
          data-cy="delete-profile-picture"
          data-testid="delete-profile-picture"
          style={{ position: 'absolute', zIndex: '2', right: '80%', top: '80%' }}
          onClick={onDelete}
        >
          <i className="fas fa-trash"></i>
        </Button>
      ) : null}
    </div>
  )
}

export { ProfileImageWithActions }
